<template>
  <el-select
    :value="value"
    @change="change"
    @click.native="selClick"
    :size="size"
    :placeholder="placeholder"
    :multiple="multiple"
    :collapseTags="collapseTags"
    :clearable="!readonly && clearable"
    filterable
    ref="sel"
    :disabled="disabled"
  >
    <el-option
      v-for="item in items"
      :key="item[valueField]"
      :label="item[labelField]"
      :value="item[valueField]"
    >
    </el-option>
  </el-select>
</template>

<script>
function IsObjChange(obj1, obj2) {
  if (obj1 && obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length != keys2.length) return true;
    if (keys1.some((x) => keys2.indexOf(x) == -1)) return true;
    for (const key in obj1) {
      if (obj1[key] != obj2[key]) return true;
    }
    return false;
  } else if (!obj1 && !obj2) return false;
  return true;
}

export default {
  model: {
    prop: "value",
    event: "changeVal",
  },
  data: function () {
    return {
      items: [],
      preExtraParam: null,
    };
  },
  props: {
    value: [Number, String, Array],
    valueField: String,
    labelField: String,
    url: String,
    multiple: Boolean,
    collapseTags: Boolean,
    clearable: Boolean,
    placeholder: String,
    size: String,

    selFirst: Boolean,
    readonly: Boolean,

    extraParam: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    useCache: Boolean,
    changeConfirm: Function,

    searchKey: {
      type: String,
      default: "numberOrName",
    },
  },
  methods: {
    selClick: function () {
      if (this.extraParam && IsObjChange(this.extraParam, this.preExtraParam)) {
        this.refresh();
      }
    },
    change: async function (val) {
      const item = this.items.filter((x) => x[this.valueField] == val)[0];
      if (this.changeConfirm) {
        var success = await this.changeConfirm(item);
        this.$refs.sel.blur();
        if (!success) return;
      }
      this.$emit("change", item);
      this.$emit("changeVal", val);
    },
    refresh: function (query) {
      const queryParam = Object.assign({}, this.extraParam);
      queryParam[this.searchKey] = query;
      const method = this.useCache ? this.$httpPostCache : this.$httpPost;
      return method.call(this, this.url, queryParam).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message);
          return;
        }

        this.preExtraParam = this.extraParam;
        this.items = res.datalist || [];
      });
    },
  },
  mounted: function () {
    this.refresh().then((res) => {
      if (this.selFirst) {
        if (this.items && this.items.length > 0) {
          this.$emit("changeVal", this.items[0][this.valueField]);
          this.$emit("change", this.items[0]);
        } else {
          this.$emit("changeVal", null);
          this.$emit("change", null);
        }
      }
    });
  },
  computed: {},
};
</script>

<style>
</style>